module.exports = __webpack_public_path__ + "img/u73.31290052.png";